import React from 'react';
import { FileText } from 'lucide-react';
import LegalDoc, { LegalDocData } from '../components/LegalDoc';
import legal from '../content/legal.json';

export default function TermsOfService() {
  return <LegalDoc doc={legal.terms as LegalDocData} icon={<FileText className="w-5 h-5 text-zinc-400" />} />;
}
